// The Capacitor shell serves the bundle from https://localhost, so neither a
// hostname nor a user-agent test can identify it — `wv` appears in the user
// agent of every Android in-app browser, which is how Facebook and Reddit
// traffic once reported itself as the app. Only the bridge is trusted.
export const isAndroidApp = typeof window !== 'undefined'
  && window.Capacitor?.isNativePlatform?.() === true

// Where the site actually lives. Inside the shell window.location.origin is
// https://localhost, which is a dead end in anything shared or opened out.
export const PUBLIC_ORIGIN = 'https://provjericijene.hr'

/** An absolute, shareable URL for a router path. */
export function publicUrl(path) {
  const origin = isAndroidApp ? PUBLIC_ORIGIN : window.location.origin
  return new URL(path, origin).toString()
}
